<template>
  <LayoutAuto class="layout-auto">
    <div class="content">
      <PersonalQuota />
      <div class="chart-wrap">
        <WhiteWrap
          tit="审批效率排行榜"
          :headerStyle="headerStyle"
          class="chart-item-wrap"
        >
          <div class="efficiency-wrap">
            <EffeciencyTop3 
              :topList="top3List" 
              class="top-three"
              @like="biOpLikes"
            />
            <EfficiencySort  
              :sortList="sortList" 
              :mySortInfo="mySortInfo"
              class="sort-all"
              @like="biOpLikes"
            />
          </div>
        </WhiteWrap>
        
        <WhiteWrap
          tit="审批量数据统计"
          :headerStyle="headerStyle"
          class="chart-item-wrap"
        >
          <ApprovalStatistics />
        </WhiteWrap>

        <WhiteWrap tit="个人审批单分布" :headerStyle="headerStyle">
          <PersonApprovalArea />
        </WhiteWrap>
      </div>
    </div>
  </LayoutAuto>
</template>

<script>
import PersonalQuota from "@/pages/Setting/DataCenter/components/PersonalQuota";
import EfficiencySort from "@/pages/Setting/DataCenter/components/EfficiencySort";
import EffeciencyTop3 from "@/pages/Setting/DataCenter/components/EffeciencyTop3";
import ApprovalStatistics from "@/pages/Setting/DataCenter/components/ApprovalStatistics";
import PersonApprovalArea from "@/pages/Setting/DataCenter/components/PersonApprovalArea";

export default {
  components: {
    PersonalQuota,
    EfficiencySort,
    EffeciencyTop3,
    ApprovalStatistics,
    PersonApprovalArea,
  },
  data() {
    return {
      quota: {},
      headerStyle: {
        background: "#F0F2F5",
      },
      sortList: [],
      mySortInfo: {isNull: true}
    };
  },
  created() {
    this.getApprovalTimeAvgSort()
  },
  computed: {
    top3List() {
      if (!this.sortList.length) return [];
      const top3Arr = this.sortList.slice(0, 3);
      const top1 = top3Arr.shift();
      top3Arr.splice(1, 0, top1);
      return top3Arr;
    },
  },
  methods: {
    getApprovalTimeAvgSort() {
      _api.dataCenter.approvalTimeAvgSort().then((data) => {
        this.sortList = (data?.records ?? []).map(el => {
          const hours = Math.floor(el.approvalTimeAvg / 3600)
          const minute = (el.approvalTimeAvg - hours * 3600) % 60
            return {
            ...el,
            formatName: this.handleName(el.name),
            approvalTimeAvgFormate: this.approvalTimeAvgFormate(el.approvalTimeAvg)
          }  
        });

        this.mySortInfo = data.currentUser && Object.keys(data.currentUser).length
          ? {
              ...data.currentUser,
              isNull: false,
              approvalTimeAvgFormate: this.approvalTimeAvgFormate(data.currentUser.approvalTimeAvg)
            }
          : { isNull: true }
      })
    },

    // 审批平均时间格式化
    approvalTimeAvgFormate(timeAvg) {
      const hours = Math.floor(timeAvg / 3600)
      const minute = Math.floor(((timeAvg - hours * 3600) / 10 ) / 6);
      const seconds = timeAvg - hours * 3600 - minute * 60;
      
      if (hours > 0) return `${hours} 小时 ${minute} 分钟`
      if (minute > 0) return `${minute} 分钟 ${seconds} 秒`
      return `${seconds} 秒`
    },
    handleName(name) {
      if (name.length > 4) return name.slice(0, 4) + '...'
      return name
    },

    // 点赞 && 取消点赞
    biOpLikes(item) {
      _api.dataCenter.biOpLikes({ targetUser: item.user })
        .then(data => {
          const index = item.sort - 1
          this.sortList.splice(index, 1, {
            ...item,
            likes: item.isContainSelf ? item.likes -  1 : item.likes + 1, 
            isContainSelf: Number(!item.isContainSelf)
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-auto {
  width: $mainContentWidth;
  padding: 0px;
  margin: 30px auto;
  // padding-bottom: 30px;
  background: #f0f2f5;
  
  .content {
    background: #ffffff;
  }
  .chart-wrap {
    padding: 25px;
    .chart-item-wrap {
      margin-bottom: 25px;
      &:last-child {
        margin-bottom: 0;
      }
      .efficiency-wrap {
        display: flex;
        .top-three {
          flex: 1;
          height: inherit;
        }
        .sort-all {
          width: 430px;
        }
      }
    }
  }
}
</style>
